module.exports = __webpack_public_path__ + "img/Mudas infectadas por Neonectria ditissima oriundas do viveiro 2.e79fc018.webp";